import React from 'react';
import { Select, Text } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  showBy: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
  },
});
/**
 * @param {10|20|50|100} selected 10 | 20 | 50 | 100
 * @param {(pageSize, event) => void} onSelect (pageSize: number, event: React.ChangeEvent<HTMLSelectElement>) => void
 */
export const SelectShowByPageSize = React.memo(({
  selected,
  onSelect,
}) => {
  const classes = useStyles();
  const pageSizes = React.useMemo(() => [10, 20, 50, 100], []);

  const thisSelectPageSize = React.useCallback((event) => {
    if (onSelect) onSelect(+event.target.value, event);
  }, [onSelect]);

  return (
    <div className={classes.showBy}>
      <Text>показывать по</Text>
      <Select value={selected} onChange={thisSelectPageSize}>
        {pageSizes.map((size) => <option key={size} value={size}>{size}</option>)}
      </Select>
    </div>
  );
});
SelectShowByPageSize.displayName = 'SelectShowByPageSize';
